import { FC } from 'react'
import { ITokenBase } from '@/types'
import { Avatar } from '@/components/atoms/Avatar'
import { getTokenLogo } from '@/utils'
import styles from './index.module.scss'

type Props = {
  token: ITokenBase
  small?: boolean
  withDot?: boolean
}

export const TokenLogoAndName: FC<Props> = ({ token, small = false, withDot = false }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={small ? styles.smallLogo : styles.logo}>
          <Avatar src={getTokenLogo(token)} alt={token?.name} />
        </div>
        <span className={styles.name}>{withDot ? `${token.name}・` : `${token.name}`}</span>
      </div>
    </div>
  )
}
